const Style = {
    wrapper: 'flex flex-col items-center justify-center w-full h-full pb-32 pt-12',
    hr: 'border-1 border-gray-300 my-4 w-full',
    logo: '-mt-16',
    title: 'text-3xl font-semibold',
    description: 'mt-8 text-xl font-light border p-4 rounded-2xl border-gray-300 text-gray-500 text-center w-1/2 mx-auto shadow',

}

export default Style